import type { ExcQuotemediaV1EodPriceTaskKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../../util/routing/entity-paths';

export const QUOTEMEDIA_EOD_PRICE_TASK_BASE_PATH = getResolvedPath('/clearing/vendor/quote-media/task');

export const getQuotemediaEodPriceTaskPath: EntityPathBuilder<ExcQuotemediaV1EodPriceTaskKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return QUOTEMEDIA_EOD_PRICE_TASK_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.taskId) {
        return undefined;
      }

      return getResolvedPath(`${QUOTEMEDIA_EOD_PRICE_TASK_BASE_PATH}/$taskId`, context.keys);
    }
  }
};

export function getQuotemediaEodPriceTaskDetailPath(taskId: string | undefined) {
  if (!taskId) {
    return undefined;
  }

  return getQuotemediaEodPriceTaskPath({ kind: 'detail', keys: { taskId } });
}
